import { CheckCircle2 } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const points = [
  {
    title: "One mentor who knows your story.",
    desc: "Your assigned mentor remains your main point of contact throughout the process, supported by our team. Each conversation builds on an understanding of your circumstances and decisions.",
  },
  {
    title: "Honest advice. Clear expectations.",
    desc: "We explain academic demands, career uncertainties and what universities can realistically provide—even when it differs from what you hoped to hear. You deserve clarity before making a commitment.",
  },
  {
    title: "An investment with a purpose.",
    desc: "A low fee, stipend or high ranking tells only part of the story. We help you weigh the qualification’s recognition and future progression, so you understand what is worth paying for.",
  },
  {
    title: "Firsthand experience. Practical preparation.",
    desc: "Our team brings experience of studying abroad and supporting students within universities. Through individual pre-departure sessions, often with families, we prepare you for everyday responsibilities, settling in and knowing where to find help.",
  },
];

export const WhyUs = () => (
  <section
    id="why"
    data-testid="why-section"
    className="relative py-20 lg:py-28 bg-[#F3EFEA]"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 flex flex-col justify-between">
          <Reveal>
            <Overline testid="why-overline">WHY MOVEMENTOR</Overline>
            <h2
              data-testid="why-heading"
              className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111]"
            >
              Personal mentoring. Thoughtful advice.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 overflow-hidden rounded-[28px] border border-black/5 bg-white shadow-[0_24px_60px_rgba(17,17,17,0.06)]">
              <div className="relative aspect-[4/3]">
                <img
                  src="/Collaborative Learning with Mentor.png"
                  alt="Students learning together in a cheerful classroom"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/70 via-[#111111]/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111]">
                    Student-first
                  </span>
                  <p className="mt-4 max-w-[220px] text-xl font-semibold leading-snug text-white">
                    Honest guidance for the right next step.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
          {points.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div
                data-testid={`why-point-${i}`}
                className="group h-full bg-white rounded-3xl border border-black/5 p-8 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-orange-500/10 transition-[transform,box-shadow] duration-500"
              >
                <CheckCircle2
                  className="w-7 h-7 text-[#FE7815]"
                  strokeWidth={2}
                />
                <h3 className="mt-5 text-lg font-semibold text-[#111111] leading-snug">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-[#111111] leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
